import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { ErrorFallback } from "@/components/error-fallback";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppRoutes } from "@/routes/app-routes";
import { store } from "@/store";

import "@/styles/global.css";

/**
 * Component representing the main application
 *
 * @returns rendered application
 */
const App = () => {
    return (
        <Provider store={store}>
            <ErrorBoundary fallback={<ErrorFallback />}>
                <TooltipProvider>
                    <BrowserRouter>
                        <AppRoutes />
                    </BrowserRouter>
                </TooltipProvider>
            </ErrorBoundary>
        </Provider>
    );
};

export { App };
